import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("image5", component(opts));
  editor.BlockManager.add("image5", block(opts));
};